import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

import { rootRouteRef } from './routes';

const teamOverviewEntityTab = EntityContentBlueprint.make({
  name: 'team-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: 'kind:group',
    routeRef: rootRouteRef,
    loader: async () => {
      const [{ TeamOverviewPage }, { ScorecardDataProvider }] =
        await Promise.all([
          import('./components/TeamOverviewPage/TeamOverviewPage'),
          import('@internal/backstage-plugin-scorecard-frontend'),
        ]);
      return (
        <ScorecardDataProvider>
          <TeamOverviewPage />
        </ScorecardDataProvider>
      );
    },
  },
});

export const teamOverviewPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'team-overview-frontend',
  extensions: [teamOverviewEntityTab],
  routes: {
    root: rootRouteRef,
  },
});
